/**
 * Simpatico FAQ Scripts
 *
 * FAQ-specific sticky navigation and accordion behavior.
 *
 * @package Simpaticobike
 * @since 3.0.1
 */

(function() {
	'use strict';

	const FAQ_NAV_HIGHLIGHT_FLAG = '__simpaticoFaqNavHighlightInitialized';
	const FAQ_BOUND_ATTR = 'data-faq-bound';

	/**
	 * Ensure sticky sidebar ancestors do not clip the FAQ layout.
	 */
	function normalizeStickyAncestors() {
		const sidebar = document.querySelector('.simpatico-faq__sidebar');
		if (!sidebar || window.innerWidth < 1024) return;

		document.documentElement.style.overflow = 'visible';
		document.documentElement.style.overflowX = 'clip';

		let el = sidebar.parentElement;
		while (el && el !== document.documentElement) {
			const style = window.getComputedStyle(el);
			const overflow = style.overflow;
			const overflowY = style.overflowY;
			if (
				overflow === 'hidden' ||
				overflow === 'auto' ||
				overflow === 'scroll' ||
				overflowY === 'hidden' ||
				overflowY === 'auto' ||
				overflowY === 'scroll'
			) {
				el.style.overflow = 'visible';
			}
			el = el.parentElement;
		}
	}

	/**
	 * Sticky FAQ navigation
	 */
	function initStickyNav() {
		const nav = document.querySelector('.simpatico-faq__nav');
		if (!nav) return;

		const headerHeight = document.querySelector('#masthead')?.offsetHeight || 80;

		// Adjust sticky position based on header
		nav.style.top = (headerHeight + 20) + 'px';
	}

	/**
	 * Active section highlighting for FAQ nav
	 */
	function initFaqNavHighlight() {
		const navLinks = document.querySelectorAll('.simpatico-faq__nav-link');
		const sections = document.querySelectorAll('.simpatico-faq__category');

		if (!navLinks.length || !sections.length || window[FAQ_NAV_HIGHLIGHT_FLAG]) return;

		const headerHeight = document.querySelector('#masthead')?.offsetHeight || 80;

		function updateActiveLink() {
			let currentSection = '';

			sections.forEach(section => {
				const sectionTop = section.offsetTop - headerHeight - 100;
				const sectionBottom = sectionTop + section.offsetHeight;

				if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionBottom) {
					currentSection = section.getAttribute('id');
				}
			});

			navLinks.forEach(link => {
				link.classList.remove('active');
				if (link.getAttribute('href') === '#' + currentSection) {
					link.classList.add('active');
				}
			});
		}

		let ticking = false;
		window.addEventListener('scroll', () => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					updateActiveLink();
					ticking = false;
				});
				ticking = true;
			}
		});

		updateActiveLink();
		window[FAQ_NAV_HIGHLIGHT_FLAG] = true;
	}

	/**
	 * Accordion functionality for FAQ page.
	 */
	function initAccordions() {
		const accordions = document.querySelectorAll('.simpatico-accordion');

		if (!accordions.length) return;

		document.body.classList.add('simpatico-faq-page--enhanced');
		document.querySelector('.simpatico-faq-page')?.classList.add('simpatico-faq-page--enhanced');

		const syncItemState = (item, isOpen) => {
			const trigger = item.querySelector('.simpatico-accordion__trigger');
			const content = item.querySelector('.simpatico-accordion__content');

			item.classList.toggle('is-open', isOpen);

			if (trigger) {
				trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			}

			if (content) {
				content.hidden = !isOpen;
			}
		};

		const handleTriggerClick = (event) => {
			const trigger = event.currentTarget;
			const item = trigger.closest('[data-accordion]');
			const accordion = item?.closest('.simpatico-accordion');

			if (!item || !accordion) {
				return;
			}

			event.preventDefault();

			const isOpen = item.classList.contains('is-open');

			accordion.querySelectorAll('[data-accordion]').forEach((candidate) => {
				syncItemState(candidate, false);
			});

			if (!isOpen) {
				syncItemState(item, true);
			}
		};

		accordions.forEach((accordion) => {
			accordion.querySelectorAll('[data-accordion]').forEach((item) => {
				syncItemState(item, item.classList.contains('is-open'));

				const trigger = item.querySelector('.simpatico-accordion__trigger');
				if (!trigger || trigger.getAttribute(FAQ_BOUND_ATTR) === 'true') {
					return;
				}

				trigger.addEventListener('click', handleTriggerClick);
				trigger.setAttribute(FAQ_BOUND_ATTR, 'true');
			});
		});

	}

	function init() {
		normalizeStickyAncestors();
		initStickyNav();
		initFaqNavHighlight();
		initAccordions();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	window.addEventListener('load', init);
	window.addEventListener('pageshow', init);
})();
